export const supportsFairPlay = async () => {
  try {
    await navigator.requestMediaKeySystemAccess('com.apple.fps', [
      {
        initDataTypes: ['cenc', 'sinf', 'skd'],
        videoCapabilities: [
          {
            contentType: 'video/mp4; codecs="avc1.42E01E"',
          },
        ],
      },
    ]);
    return true;
  } catch {
    return false;
  }
};

export const isHlsType = (mimeType: string) => {
  return mimeType === 'application/x-mpegurl' || mimeType === 'application/vnd.apple.mpegurl';
};

export const isMpegDash = (mimeType: string) => {
  return mimeType === 'application/dash+xml';
};
